import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { FeedbackMasterApiService } from 'src/app/services/feedback-master-api.service';

@Component({
    selector: 'logzy-key-insights',
    templateUrl: './key-insights.component.html',
    styleUrls: ['./key-insights.component.scss']
})
export class KeyInsightsComponent implements OnInit {
    @Input()
    isFeedbackSubmited: boolean = false;
    isCustomer: boolean;

    confirmationMessage: string;
    feedbackResponseCustomer: any = [];
    feedbackResponseInt: any = [];
    feedback_items = []
    placeholder: string;
    current_feedback_index: number;

    loading: boolean = false;
    update: boolean = false;
    requestVisibilityExpand: boolean = false;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    req_id;

    reqAllocationList: MatTableDataSource<any>;
    displayedColumns = ['allocated_from', 'allocated_to', 'updated_at', 'transfer_reason', 'remarks']

    constructor(public feedbackService: FeedbackMasterApiService, private route: ActivatedRoute, private snackBar: MatSnackBar,
        public requestService: RequestApiService,
        public authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.req_id = params['id'];
                this.getFeedbackByReqId(params['id']);
                // this.getFeedback(params['id']);
                if (!this.isCustomer) {
                    this.getRequestAllocationList(params['id']);
                }
            }
        });
    }

    getFeedbackByReqId(id) {
        this.feedbackService.getFeedbackbyReqID(id).subscribe({
            next: response => {
                this.feedbackResponseInt = []
                this.feedbackResponseCustomer = []
                for (let i = 0; i < response.results.length; i++) {
                    if (response.results[i].parameter.is_internal == true) {
                        this.feedbackResponseInt.push(response.results[i]);
                    } else {
                        this.feedbackResponseCustomer.push(response.results[i]);
                    }
                }
                this.checkFeedbackresponse(response);
                console.log("feedbackResponseCustomer", this.feedbackResponseCustomer.length)
            },
        })
    }

    getRequestAllocationList(id, pageSize = null, pageIndex = null) {
        this.loading = true;
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this.requestService.getRequestAllocationListById(id, pageSize, pageIndex + 1).subscribe({
            next: res => {
                this.pageLength = res.count;
                this.reqAllocationList = new MatTableDataSource(res.results);
                this.loading = false;
                this.update = false;
                return res;
            }, error: err => {
                console.log(err)
                return err;
            }
        })
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        console.log({ event });
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.getRequestAllocationList(this.req_id, this.pageSize, this.pageIndex);
    }

    // Add Change Rating Button amd Update Feedback
    // getFeedback(id) {
    //   this.feedbackService.getFeedback(id).subscribe({
    //     next: response => {
    //       this.feedback_items = response.results.map(item => {
    //         return {
    //           parameter: item.id,
    //           question: item.value,
    //           request: id,
    //           rating: null,
    //           remarks: '',
    //         }
    //       });
    //     },
    //     error: error => {
    //       console.log(error)
    //       return error;
    //     }
    //   });
    // }

    // set_rating(rating, index) {
    //     this.current_feedback_index = index;
    //     // this.feedbackResponse[index].rating = rating;
    //     this.feedbackResponse[index].rating = rating;

    //     switch (index) {
    //         case 0:
    //             this.placeholder = "This is really not acceptable. We are all ears to hear your grievance to improve and do better the next time.";
    //             break;
    //         case 1:
    //             this.placeholder = "We take such feedback very seriously. Please share your feedback to do this better next time."
    //             break;
    //         case 2:
    //             this.placeholder = "Let us know how can we improve to make it better the next time."
    //             break;

    //         default:
    //             break;
    //     }

    // }
    updateFeedbackSubmit(item) {
        // let data = this.feedback_items[this.current_feedback_index];
        // data['parameter'] =data['parameter'].id;
        // this.feedbackService.updateFeedback(this.feedback_items,data.id).subscribe({
        // let data = this.feedback_items[this.current_feedback_index];
        item['parameter'] = item['parameter'].id;
        this.feedbackService.updateFeedback(item, item.id).subscribe({
            next: response => {
                this.current_feedback_index = null;
                this.snackBar.open("Update Pick-up Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    feedbackSubmit(a) {
        this.isFeedbackSubmited = a;
        this.getFeedbackByReqId(this.requestService.selectedRequest.id)
        // this.confirmationSrc = "assets/images/backgrounds/business.svg";
        this.confirmationMessage = "Thanks for sharing your valuable feedback.";
    }

    checkFeedback(a) {
        if (a.count > 0) {
            this.isFeedbackSubmited = true;
            console.log('this.feedbackSubmited', this.isFeedbackSubmited)
            console.log("response a", a)
        } else {
            this.isFeedbackSubmited = false;
            console.log('this is not what i thought')
            console.log("response else a", a)

        }
    }

    checkFeedbackresponse(response) {
        if (response.results.length > 0) {
            this.isFeedbackSubmited = true;
        } else {
            this.isFeedbackSubmited = false;
        }
    }
}


